import React from "react";
import Modal from "../../common/modal";
import CaseDetails from "./caseDetail/CaseDetails";
import CaseNotes from "./caseDetail/CaseNotes";
import CaseDocuments from "./caseDetail/CaseDocuments";
import CaseHistory from "./caseDetail/CaseHistory";
import CaseUpdate from "./caseDetail/CaseUpdate";
import { DiscoverConstants } from "../../../configurations/discoverConfigs/discoverConstants";

const initialState = {
  showCaseSummary: false,
  showCaseNotes: false,
  showCaseHistory: false,
  showCaseDocuments: false,
  showUpdateCase: false
};

class DiscoverCaseDetailsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.showView = this.showView.bind(this);
  }

  componentDidMount() {
    this.props.getCaseDocuments(this.props.caseDetails.caseNumber);
    this.setState({
      showCaseSummary: true
    });
  }

  showView(event) {
    const { target } = event.target.dataset;
    const stateUpdate = {};
    stateUpdate[target] = true;
    const newState = {
      ...initialState,
      ...stateUpdate
    };
    this.setState(prevState => {
      if (prevState.showUpdateCase) {
        if (window.confirm("Are you sure you want to exit?")) {
          return newState;
        }
      } else {
        return newState;
      }
    });
  }

  render() {
    const {
      caseDetails,
      isOpen,
      onRequestClose,
      getCaseDetail,
      documents,
      getCaseDocuments,
      fetchingDocuments
    } = this.props;
    const {
      showCaseDocuments,
      showCaseNotes,
      showUpdateCase,
      showCaseSummary,
      showCaseHistory
    } = this.state;

    const casePermissions = caseDetails.caseActions.map(action => {
      return action.replace(/\s/g, "_");
    });
    return (
      <Modal
        title="Discover Case Details"
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <hr />
        <div className="row">
          <div className="col-xs-12 text-center">
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.viewCaseDetails
            ) >= 0 ? (
              <button
                data-target="showCaseSummary"
                className={`btn btn-primary ${showCaseSummary && "active"}`}
                onClick={this.showView}
                disabled={showCaseSummary}
              >
                Case Details
              </button>
            ) : (
              ""
            )}{" "}
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.viewCaseNotes
            ) >= 0 ? (
              <button
                data-target="showCaseNotes"
                className={`btn btn-primary ${showCaseNotes && "active"}`}
                onClick={this.showView}
                disabled={showCaseNotes}
              >
                Case Notes
              </button>
            ) : (
              ""
            )}{" "}
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.viewCaseHistory
            ) >= 0 ? (
              <button
                data-target="showCaseHistory"
                className={`btn btn-primary ${showCaseHistory && "active"}`}
                onClick={this.showView}
                disabled={showCaseHistory}
              >
                Case History
              </button>
            ) : (
              ""
            )}{" "}
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.viewCaseDocuments
            ) >= 0 ? (
              <button
                data-target="showCaseDocuments"
                className={`btn btn-primary ${showCaseDocuments && "active"}`}
                onClick={this.showView}
                disabled={showCaseDocuments}
              >
                Case Documents
              </button>
            ) : (
              ""
            )}{" "}
            {casePermissions.indexOf(
              DiscoverConstants.caseUpdatePermissions.updateCase
            ) >= 0 ? (
              <button
                data-target="showUpdateCase"
                className={`btn btn-primary ${showUpdateCase && "active"}`}
                onClick={this.showView}
                disabled={showUpdateCase}
              >
                Update Case
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <hr />
        {showCaseSummary && <CaseDetails caseDetails={caseDetails} />}
        {showCaseNotes && (
          <CaseNotes
            caseDetails={caseDetails}
            casePermissions={casePermissions}
            getCaseDetails={getCaseDetail}
          />
        )}
        {showCaseDocuments && (
          <CaseDocuments
            casePermissions={casePermissions}
            caseDetails={caseDetails}
            getCaseDocuments={getCaseDocuments}
            documents={documents}
            fetchingDocuments={fetchingDocuments}
          />
        )}
        {showCaseHistory && <CaseHistory caseDetails={caseDetails} />}
        {showUpdateCase && (
          <CaseUpdate
            caseDetails={caseDetails}
            getCaseDetails={getCaseDetail}
          />
        )}
      </Modal>
    );
  }
}

export default DiscoverCaseDetailsModal;



// WEBPACK FOOTER //
// ./src/components/discover/cases/DiscoverCaseDetailsModal.js